import { message } from 'antd';
import type { invitedSupplierI, SupplierI } from '../pages/TenderViewPage/types';

/** Matches renderCandidateEmailRow + manager row in design/launch supplier lists. */
export const collectInvitedSupplierEmails = (items: invitedSupplierI[]): string[] => {
    const emails: string[] = [];

    items.forEach((item) => {
        if (item?.manager?.name) {
            const managerEmail = item.manager.email?.trim();
            if (managerEmail) {
                emails.push(managerEmail);
            }
            return;
        }

        const candidateEmail = item?.company?.candidate_email?.trim();
        if (candidateEmail) {
            emails.push(candidateEmail);
        }
    });

    return emails;
};

/** Matches SupplierCardForTR / SupplierCardForTREvaluate2 / Evaluate4PendingTR UI. */
export const collectTenderSupplierEmails = (suppliers: SupplierI[]): string[] => {
    const emails: string[] = [];

    suppliers.forEach((item) => {
        if (!item?.manager_name) {
            return;
        }
        const email = item.email?.trim();
        if (email) {
            emails.push(email);
        }
    });

    return emails;
};

export const copyEmailsToClipboard = async (emails: string[]): Promise<void> => {
    const text = emails.join(' ').trim();

    if (!text) {
        message.warning('No emails to copy');
        return;
    }

    try {
        await navigator.clipboard.writeText(text);
        message.success('Supplier emails copied to clipboard successfully');
    } catch {
        message.error('Failed to copy emails to clipboard');
    }
};
